import React from 'react';

export default function LazyloadImage({ source, placeholder, className, ...props }) {
  return (
    <img
      src={ placeholder || "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" }
      data-src={ source }
      className={ `${className ? className : ''} lazyload` }
      { ...props }
    />
  );
}